import React, {useMemo} from "react";
import YoutubeVideoPlayer, {VideoTypes} from "../../../base/video-player/youtube";
import {Link} from 'react-router-dom';
import {routeFunctions} from "../../../../../core/models/static/routes/app-routes";
import NativeVideoPlayer from "../../../base/video-player/native";
import DateUtils from "../../../../../core/services/date-utils";
import {Card} from "@mui/material";


const ContentVideo = ({data}) => {
    const isVideoFromYoutube = useMemo(() => data?.url?.startsWith('https://www.youtube') ?? false, [data?.url]);
    const link = useMemo(() => routeFunctions.content.videos.single(data?.slug), [data?.slug]);

    return (
        <>
            <Card variant={'outlined'} component={Link} to={link} className={'content-mini-video'}>
                <div className={'content-mini-video-header'}>
                    <p className={'title'}>
                        {data?.title}
                    </p>
                    <p className={'date'}>
                        {data?.lastModifyDateTime
                            ? DateUtils.serverToLocal(data.lastModifyDateTime).format(DateUtils.dateFormatAlternative)
                            : ''
                        }
                    </p>
                </div>
                <div className={'content-mini-video-body'} onClick={e => e.stopPropagation() || e.preventDefault()}>
                    {
                        isVideoFromYoutube
                            ? <YoutubeVideoPlayer
                                key={data.id}
                                id={`video-${data.id}`}
                                videoId={data.url?.split('/')[data.url?.split('/').length - 1]}
                                type={VideoTypes.small}
                                title={data.title}
                            />
                            : <NativeVideoPlayer
                                key={data.id}
                                id={`video-${data.id}`}
                                src={data.url}
                                type={VideoTypes.small}
                                title={data.title}
                            />
                    }
                </div>
            </Card>
        </>
    )
}

export default ContentVideo;
